const normalizeExperiments = (experiments) => {
  const result = {}

  for (const key in experiments) {
    const exp = experiments[key]
    result[key] = {
      ...exp,
      value: exp.value === undefined ? null : exp.value,
    }
  }

  return result
}

export default normalizeExperiments
